import React, {Fragment, ReactElement, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import EnrolmentMessage from '../../components/common/EnrolmentMessage';
import EnrolmentForm from '../../components/common/EnrolmentForm';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import {updateProfile, resetState, error} from '../../redux/userProfileSlice';
import {setAppBarTitle, setBackNavEnabled} from '../../redux/globalSlice';
import TermsAndCondtion from '../../core/terms-condtion';

import {
  fetchCustomerProfile,
  customerProfile,
} from '../../redux/customerSearchSlice';
import Modal from '../../components/modal/Modal';
import {whatsApi, whatsappData} from '../../redux/yellowMessengerSlice';
import cogoToast from 'cogo-toast';
import {
  getAccessToken,
  getPhoneNumber,
  getStoreCode,
  getUser,
} from '../../core/localstorage-data';
import {HOME_ROUTE_PATH} from '../../routes/route-constants';
import ErrorToast from '../../components/notifications/ErrorToast';
import SuccessToast from '../../components/notifications/SuccessToast';
import {setPageName} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';

interface FormData {
  date: string;
  email: string;
  firstName: string;
  lastName: string;
  gender: string;
  whatsappAPI: boolean;
  pincode:string;
  terms: boolean;
}

const ProfileUpdate = (): ReactElement => {
  const history = useHistory();
  const accessToken = getAccessToken();
  const storeCode = getStoreCode();
  const updateProfileResponse = useAppSelector(state => {
    return state.profileReducer.updateProfileResponse;
  });

  const whatsappApiData = useAppSelector(whatsappData);
  const customerProfileData = useAppSelector(customerProfile);
  const updateProfileError = useAppSelector(error);
  let mobile: string | null = null;
  mobile = getPhoneNumber();
  const [whatsappStatus, setWhatsappStatus] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);

  useEffect(() => {
    setPageName(pageName.updateProfilePage);
  }, []);
  useEffect(() => {
    if (
      updateProfileResponse &&
      updateProfileResponse.result &&
      whatsappStatus === true
    ) {
      if (mobile !== null) {
        dispatch(whatsApi({mobile}));
      }
      cogoToast.success(
        <SuccessToast
          title="Success!"
          description="Profile updated successfully"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
    }

    //if updateprofile response is 200 but result is false
    if (updateProfileResponse && updateProfileResponse.result === false) {
      //error

      cogoToast.error(
        <ErrorToast title="Error" description="Something went wrong, Please try again." />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }

    // if user select whatsapp and user data has error
    if (updateProfileError && whatsappStatus == true) {
      //error
      cogoToast.error(
        <ErrorToast title="Error" description="Something went wrong, Please try again." />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [updateProfileResponse, updateProfileError]);

  useEffect(() => {
    if (
      updateProfileResponse &&
      updateProfileResponse.result === true &&
      whatsappApiData &&
      whatsappApiData.message.data.number == mobile //TODO: Mobile number fetch from localstorage
    ) {
      //history.goBack();
      history.replace(HOME_ROUTE_PATH);
      //  history.push(HOME_ROUTE_PATH);
    }
    return () => {
      dispatch(resetState());
    };
  }, [whatsappApiData]);

  useEffect(() => {
    dispatch(setAppBarTitle('Update profile'));
    dispatch(setBackNavEnabled(true));

    if (accessToken) {
      const parameters = {
        payload: {
          source: 'MAXBUDDY',
          locationCode: 'BNG',
          mobileNumber: mobile,
        },
        accessToken: accessToken,
      };

      dispatch(fetchCustomerProfile(parameters));
    }
    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle, fetchCustomerProfile]);

  const dispatch = useAppDispatch();

  function submitHandler(formData: FormData) {
    setWhatsappStatus(formData.whatsappAPI);
    const parameter = {
      payload: {
        mobileNo: mobile,
        firstName: `${formData.firstName}`,
        lastName: `${formData.lastName}`,
        email: formData.email,
        date_Of_Birth: formData.date,
        gender: formData.gender,
        pincode: `${formData.pincode}`,
      },
      accessToken: accessToken,
    };
    //TODO: dispatch the action
    dispatch(updateProfile(parameter));
  }
  return (
    <Fragment>
      <div className="container mx-auto z-10 p-4">
        <div className="w-auto bg-white md:p-16 top-spacing-ipad">
          <EnrolmentMessage />
          <EnrolmentForm
            buttonTitle="Update profile"
            submitCallback={submitHandler}
            openTnCModal={() => {
              setIsModelOpen(true);
            }}
            customerProfileData={customerProfileData}
          />
        </div>
      </div>
      {isModelOpen && (
        <Modal
          title="Terms & Conditions"
          isVisible={isModelOpen}
          onModalClosed={() => {
            setIsModelOpen(false);
          }}>
          <TermsAndCondtion />
        </Modal>
      )}
    </Fragment>
  );
};

export default ProfileUpdate;
